import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAtom, useSetAtom } from "jotai";
import { Button } from "wiz-front-shared/components/button/Button";
import { withdrawDataAtom, pushWithdrawStepAtom } from "store/withdrawStore";
import './Withdraw.css';

const REASON_KEYS = ["notUseful", "privacy", "switchService", "tooComplex", "other"] as const;

export const WithdrawStep2 = () => {
    const { t } = useTranslation();
    const [data, setData] = useAtom(withdrawDataAtom);
    const pushStep = useSetAtom(pushWithdrawStepAtom);

    const [reason, setReason] = useState<string>(data.reason);
    const [feedback, setFeedback] = useState<string>(data.feedback);

    const isOther = reason === "other";

    const handleNext = () => {
        // 사유/기타 입력 모두 선택 사항 — 비어있어도 다음 진행 가능
        setData(prev => ({
            ...prev,
            reason,
            feedback: isOther ? feedback.trim() : "",
        }));
        pushStep(3);
    };

    return (
        <div className="withdraw-step">
            <span className="title">{t("withdraw.step2.title")}</span>
            <span className="info">{t("withdraw.step2.info")}</span>

            <div className="withdraw-reason-label">{t("withdraw.step2.reasonLabel")}</div>

            <ul className="withdraw-reason-list">
                {REASON_KEYS.map(key => {
                    const selected = reason === key;
                    return (
                        <li
                            key={key}
                            className={`withdraw-reason-item ${selected ? "selected" : ""}`}
                            onClick={() => {
                                setReason(key);
                                if (key !== "other") setFeedback("");
                            }}
                        >
                            <span className={`withdraw-reason-radio ${selected ? "selected" : ""}`}>
                                {selected && <span className="withdraw-reason-radio-dot" />}
                            </span>
                            <span className="withdraw-reason-text">
                                {t(`withdraw.step2.reasons.${key}`)}
                            </span>
                        </li>
                    );
                })}
            </ul>

            {isOther && (
                <textarea
                    className="withdraw-feedback"
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder={t("withdraw.step2.feedbackPlaceholder")}
                    maxLength={500}
                    autoFocus
                />
            )}

            <div className="withdraw-bottom-btn">
                <Button
                    text={t("withdraw.btnNext")}
                    onPress={handleNext}
                />
            </div>
        </div>
    );
};
